import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useStore } from "../stores/store";
import { observer } from "mobx-react-lite";
import RequireSubscription from "./RequireSubscription";

const RequireAuth = () => {
    const { userStore } = useStore();
    const location = useLocation();

    if (!userStore.isLoggedIn) {
        return <Navigate to='/' state={{ from: location }} />;
    }

    return (
        <RequireSubscription>
            <Outlet />
        </RequireSubscription>
    );
};

export default observer(RequireAuth);
